import { ImageTypes } from "~enums/imageTypes";
import type { RoleResponse } from "~types/role";
import { findImageByTypes } from "~utilities/findImageByTypes.ts";

export const transformRoleResponse = (responseData: RoleResponse) => {
  const resources = responseData.includes?.resources;
  return responseData.data.map((role) => {
    const resourcePerson = resources?.persons?.[role.person.id];
    const resourceEntity = role.entity ? resources?.entities?.[role.entity.id] : undefined;
    const resourceEntityGroup = role.entityGroup ? resources?.entityGroups?.[role.entityGroup.id] : undefined;

    const avatarUrl = findImageByTypes(resourcePerson?.images, [ImageTypes.PersonHead])?.url ?? "";

    return {
      avatarUrl,
      bib: role.bib ?? "",
      dateFrom: role.dateFrom ?? "",
      dateTo: role.dateTo ?? "",
      entityGroupNameFullLocal: resourceEntityGroup?.nameFullLocal ?? "",
      entityNameFullLocal: resourceEntity?.nameFullLocal ?? "",
      externalId: resourcePerson?.externalId ?? "",
      gender: resourcePerson?.gender ?? "",
      nameFullLocal: resourcePerson?.nameFullLocal ?? "",
      nationality: resourcePerson?.nationality ?? "",
      personId: resourcePerson?.personId ?? role.personId,
      role: role.role,
      roleId: role.roleId,
      roleNumber: role.roleNumber ?? "",
      roleSubType: role.roleSubType ?? "",
      status: role.status ?? "",
    };
  });
};
